export enum States {
  INITIAL,
  RUNNING,
  PAUSED,
  EXPIRED,
}
